import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation SetPrintRuleAssignment($input: SetPrintRuleAssignmentInput!) {
    setPrintRuleAssignment(input: $input) {
      id
      menuId
      menuPrintRuleId
    }
  }
`);

export function useSetPrintRuleAssignment() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRuleList', 'GetPrintRuleAssignment', 'checkPrintRuleAssignment'],
  });
}
